import { render, staticRenderFns } from "./PartySongs.vue?vue&type=template&id=182f2c84&scoped=true&"
import script from "./PartySongs.vue?vue&type=script&lang=js&"
export * from "./PartySongs.vue?vue&type=script&lang=js&"
import style0 from "./PartySongs.vue?vue&type=style&index=0&id=182f2c84&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182f2c84",
  null
  
)

export default component.exports